import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/AuthContext";
import { EditGateProvider } from "@/components/EditGate";
import { UnsavedProvider } from "@/components/UnsavedGuard";
import AuthPage from "@/pages/AuthPage";
import Layout from "@/components/Layout";
import IngredientsPage from "@/pages/IngredientsPage";
import IngredientDatabasePage from "@/pages/IngredientDatabasePage";
import RecipeDirectoryPage from "@/pages/RecipeDirectoryPage";
import RecipeBuilderPage from "@/pages/RecipeBuilderPage";
import MenuDashboardPage from "@/pages/MenuDashboardPage";
import PlannersPage from "@/pages/PlannersPage";
import B2BPricingPage from "@/pages/B2BPricingPage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="flex h-screen items-center justify-center text-sm text-zinc-500">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<AuthPage />} />
          <Route path="/" element={<Protected><EditGateProvider><UnsavedProvider><Layout /></UnsavedProvider></EditGateProvider></Protected>}>
            <Route index element={<Navigate to="/ingredients" replace />} />
            <Route path="ingredients" element={<IngredientsPage />} />
            <Route path="database" element={<IngredientDatabasePage />} />
            <Route path="recipes" element={<RecipeDirectoryPage />} />
            <Route path="recipes/new" element={<RecipeBuilderPage />} />
            <Route path="recipes/:id" element={<RecipeBuilderPage />} />
            <Route path="menu" element={<MenuDashboardPage />} />
            <Route path="planners" element={<PlannersPage />} />
            <Route path="b2b-pricing" element={<B2BPricingPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
